module.exports = __webpack_public_path__ + "static/media/logo-face.afd22fa7.svg";